import { AppService, APP_MODE } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { ResponseWorkflowOnlineService } from './response-workflow-online.service';
import { ResponseWorkflowOfflineService } from './response-workflow-offline.service';
import { ResponseWorkflowService } from './response-workflow.service';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';
import { AuthService } from '../auth/auth.service';
import { DatasourceService } from '../datasource/datasource.service';

const ResponseWorkflowServiceFactory = (appService: AppService, httpClient: HttpClient, apiService: ApiService, authService: AuthService, unitOfWork: UnitOfWorkOfflineDao) =>
    appService.AppMode == APP_MODE.ONLINE_MODE ? 
    new ResponseWorkflowOnlineService(unitOfWork, httpClient, apiService) : new ResponseWorkflowOfflineService(unitOfWork, authService);

export const ResponseWorkflowServiceProvider = { 
    provide: ResponseWorkflowService,
    useFactory: ResponseWorkflowServiceFactory,
    deps: [AppService, HttpClient, ApiService, AuthService, UnitOfWorkOfflineDao]
};